var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',_vm._g({staticClass:"egl-pagination",attrs:{"background":true,"layout":"prev, pager, next","total":_vm.total,"page-size":_vm.pageSize,"current-page":_vm.curPage +1}},_vm.allListeners))}
var staticRenderFns = []

export { render, staticRenderFns }